import { DatePicker, Form, Input, Select } from "antd";
import { useForm } from "antd/lib/form/Form";
import TextArea from "antd/lib/input/TextArea";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Authorization from "../../../../component/Authorization";
import { DebounceSelect } from "../../../../component/DebounceSelect";
import MPageHeader from "../../../../component/PageHeader";
import { SpinContext } from "../../../../component/Spin/spin.context";
import { spinActions } from "../../../../component/Spin/spin.reducer";
import { dialog } from "../../../../helper/dialog";
import helper from "../../../../helper/helper";
import { UserUI } from "../../user/entity/user.model";
import { RouteContext } from "../../user/screen/components/route.context";
import { userService } from "../../user/service/user.service";
import { Assignment, TaskStatus } from "../entity/task.model";
import { taskService } from "../service/task.service";
import AssignmentComments from "./component/AssignmentComments";

function EditAssignment() {
  const { Option } = Select;
  let { assignmentId } = useParams();
  let navigate = useNavigate();
  const [assignment, setAssignment] = useState<Assignment>();
  const { dispatch } = useContext(SpinContext);
  const { state } = useContext(RouteContext);
  const [form] = useForm();

  useEffect(() => {
    if (assignmentId) {
      dispatch({ type: spinActions.BLOCK });
      taskService
        .getAssignment(assignmentId)
        .then((_assignment: Assignment) => {
          setAssignment(_assignment);
          form.setFieldsValue(_assignment);
        })
        .finally(() => {
          dispatch({ type: spinActions.UNBLOCK });
        });
    }

    return () => {
      setAssignment(undefined);
    };
  }, [assignmentId]);

  const onFinish = async (_assignment: Assignment) => {
    if (state?.routeId.length > 0) {
      _assignment.routeId = state.routeId;

      if (assignment?.uuid) {
        _assignment.uuid = assignment.uuid;
        await taskService.editAssignment(_assignment);
      } else {
        await taskService.addAssignment(_assignment);
      }

      dialog.success(
        `Оноосон ажил амжилттай ${
          !assignment?.uuid ? "нэмэгдлээ" : "шинэчлэгдлээ"
        }.`
      );

      navigate("/assignments");
    } else {
      dialog.error("Route сонгоно уу.");
    }
  };

  return (
    <>
      <MPageHeader crumbs={["Оноосон ажлууд", assignment?.uuid ?? ""]} />
      <div className="content">
        <div className="card">
          <div className="card-header header-elements-inline">
            <h5 className="card-title">Оноосон ажлын мэдээлэл</h5>
          </div>
          <div className="card-body">
            <fieldset disabled={!helper.hasRoles(["task-full"])}>
              <Form form={form} onFinish={onFinish}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Үүсгэсэн ажилтан</label>
                      <Form.Item name="createdBy">
                        <Input disabled />
                      </Form.Item>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Үүсгэсэн огноо</label>
                      <Form.Item name="createdMoment">
                        <DatePicker
                          placeholder="Огноог сонгоно уу"
                          showTime
                          disabled
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Хариуцсан ажилтан</label>
                      <Form.Item
                        name="user"
                        rules={[
                          {
                            required: true,
                            message: "Хэрэглэгчийн нэрийг оруулна уу.",
                          },
                        ]}
                      >
                        <DebounceSelect<UserUI>
                          showSearch
                          disabled={!helper.hasRoles(["task-full"])}
                          placeholder="Хайх"
                          fetchOptions={(search) => {
                            return userService.getUsers(search, state.routeId);
                          }}
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Огноо</label>
                      <Form.Item name="assignedMoment">
                        <DatePicker
                          placeholder="Огноог сонгоно уу"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Гарчиг</label>
                      <Form.Item
                        name="title"
                        rules={[
                          {
                            required: true,
                            message: "Гарчигийг оруулна уу.",
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Төлөв сонгох</label>
                      <Form.Item
                        name="status"
                        rules={[
                          {
                            required: assignmentId !== undefined,
                            message: "Төлвийг сонгоно уу.",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Төлөв сонгох"
                          disabled={!assignmentId}
                        >
                          <Option value={TaskStatus.NEW}>
                            {helper.getTaskStatus(TaskStatus.NEW)}
                          </Option>
                          <Option value={TaskStatus.PENDING}>
                            {helper.getTaskStatus(TaskStatus.PENDING)}
                          </Option>
                          <Option value={TaskStatus.DECLINED}>
                            {helper.getTaskStatus(TaskStatus.DECLINED)}
                          </Option>
                          <Option value={TaskStatus.APPROVED}>
                            {helper.getTaskStatus(TaskStatus.APPROVED)}
                          </Option>
                          <Option value={TaskStatus.CANCELED}>
                            {helper.getTaskStatus(TaskStatus.CANCELED)}
                          </Option>
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="form-group">
                    <label>Тайлбар</label>
                    <Form.Item name="description">
                      <TextArea rows={5} />
                    </Form.Item>
                  </div>
                </div>
                <Authorization roles={["task-full"]}>
                  <div className="text-right">
                    <button type="submit" className="btn btn-primary">
                      Хадгалах <i className="icon-floppy-disk ml-2" />
                    </button>
                  </div>
                </Authorization>
              </Form>
            </fieldset>
          </div>
        </div>
        <AssignmentComments assignmentUuid={assignmentId} />
      </div>
    </>
  );
}

export default EditAssignment;
